import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import empStatusRequestBody from "./empStatusRequestBody";

export default class empStatusService {
    request = new empStatusRequestBody();
    static shared = new empStatusService();
    
    documentsUploadRequest =(payload) => {
      return new Promise((resolve, reject) => {
        WebService.clientShared
          .callServiceApi(
            ApiUrl.uploadDocuments(),
            this.request.documentsUploadRequest(payload, REQUEST_METHOD.POST)
          )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    } 

    empStatusRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.empStatusRequest(),
              this.request.empStatusRequest(payload, REQUEST_METHOD.POST)
            )
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      } 

      getEmpStatusRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getEmpStatusRequest(payload),
              this.request.getEmpStatusRequest(REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      }

      getDocTypesRequest = (payload) => {
        return new Promise((resolve, reject) => {
          WebService.clientShared
            .callServiceApi(
              ApiUrl.getDocumentTypesRequest(payload),
              this.request.getDocTypesRequest(REQUEST_METHOD.GET)
            )
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
}
